import styled from "styled-components";

export const ContainerDiv = styled.div`
  display: flex;
  padding: 1rem;
  margin-top: 2rem;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;